<script>
export default {
    name: 'SidebarItem',

    props: {
        item: Object,
        showFull: Boolean,
    },

    computed: {

        itemCheck() {
            const rights = window.JSON.parse(window.localStorage.getItem('P_102'));

            const filteredRoutes = rights.filter(right => right.name == this.item.route);

            return filteredRoutes;
        },

        subItems() {

            const rights = window.JSON.parse(window.localStorage.getItem('P_102'));

            var children = [];

            if(this.item.children.length) {

                children = this.item.children.filter(item => rights.map(r => r.name).includes(item.route));
            }

            return children;
        },
    },
}
</script>
<template>
    <li class="flex-1">
        <router-link class="sidebar-item md:py-1 text-sm rounded" 
            v-if="item.route && itemCheck.length" :to="{name : item.route}" 
            :class="$route.name == item.route ? 'border-b-2 border-yellow-500' : ''">
            <i :class="`fa fa-${item.icon} pr-0 md:pr-3 text-xs`"></i>
                <span  v-if="showFull" 
                class="sidebar-item-text md:pb-0 md:inline-block md:text-sm md:text-white">{{ item.name }} 
                </span>
        </router-link>
        <a v-if="subItems.length" href="javascript:void(0)" 
            class="sidebar-item whitespace-no-wrap md:py-2 rounded text-sm" 
            @click.prevent="item.expand = !item.expand">
            <i :class="item.expand ? `fa fa-minus pr-0 md:pr-3 text-xs` : 
                `fa fa-${item.icon} text-xs pr-0 md:pr-3`"></i>
                    <span v-if="showFull" 
                        class="sidebar-item-text md:pb-0 md:inline-block md:text-sm md:text-white">
                            {{ item.name }} </span>
        </a>
        <ul class="bg-gray-800 border-b" v-if="item.expand">
            <li class="" v-for="(subItem, index) in subItems" :key="index">
                <router-link v-if="subItem.route" :to="{ name: subItem.route }" 
                    :class="$route.name == subItem.route ? 
                        `bg-white text-gray-900 rounded` : `text-white`" 
                            class="sidebar-subitem text-xs md:py-1 md:-mr-2">
                    <span class="sidebar-item-text md:pb-0 md:inline-block md:text-sm">
                        <i class="fa fa-notes-medical mr-2"></i> 
                            <span v-if="showFull">{{ subItem.name}}</span> </span>
                </router-link>
                <a v-else href="javascript:void(0)" @click.prevent="subItem.expand = !subItem.expand" 
                    class="sidebar-subitem border-b md:py-1 text-xs text-white">
                    <i :class="subItem.expand ? `fa fa-minus mr-2` : `fa fa-plus mr-1`"></i>
                        <span v-if="showFull">{{ subItem.name}}</span></a>
                <ul class="" v-if="subItem.expand">
                    <li class="px-1" v-for="(subItemChild, index) in subItem.children" 
                        :key="`sub-child-${index}`">
                        <router-link v-if="subItemChild.route" 
                            :class="$router.currentRoute.name == subItemChild.route ? 
                                'border-b-2 border-blue-300' : ''" :to="{ name: subItemChild.route }" 
                                    class="sidebar-subitem  md:mr-4">
                            <span 
                                class="sidebar-item-text text-xs md:pb-0 md:inline-block md:text-xs 
                                    text-white whitespace-no-wrap">
                                        <i class="fa fa-notes-medical mr-1"></i> 
                                        <span v-if="showFull">{{ subItemChild.name}}</span></span>
                        </router-link>
                    </li>
                </ul>
            </li>
        </ul>
    </li>
</template>
